import useSWRImmutable from 'swr/immutable';

import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getProductSuppliers } from 'src/utils/firebase/firebase-short-cut';

const fetchProductSuppliers = (where: WHERE[]) => getProductSuppliers(where);

const useSWRProductSuppliers = (where: WHERE[] | null) => {
  const {
    data: productSuppliers,
    isLoading,
    mutate,
  } = useSWRImmutable(
    where ? `productSuppliers-${where.join('-')}` : 'productSuppliers',
    () => fetchProductSuppliers(where as WHERE[]),
    {
      errorRetryCount: 2,
    }
  );

  return {
    productSuppliers,
    isLoading,
    refresh: () => mutate(undefined, { revalidate: true }),
  };
};

export default useSWRProductSuppliers;
